module.exports = __webpack_public_path__ + "6a2508b8dd9fef000ac01f53b1c8cd76.png";